/**
 * Odpowiedzi użytkownika potrzebne do VoltValue Projektu: gdzie stoi instalacja,
 * jak jest ustawiona, ile dom zużywa i kiedy.
 *
 * DLACZEGO OSOBNY MAGAZYN, a nie doklejenie do `wybranyZestaw`: te odpowiedzi opisują
 * DOM, a nie zestaw. Przetrwają podmianę produktów, powrót do doboru i wybór innego
 * wariantu — a właśnie wtedy najbardziej boli konieczność odpowiadania od nowa.
 *
 * Wypełniane z dwóch stron: kalkulatorem mocy na stronie głównej (kto przez niego
 * przeszedł, ma komplet od razu) albo formularzem w samym mini‑projekcie.
 */

import { KONSTRUKCJA_DOMYSLNA } from './konstrukcja'
import { kluczKraju } from '../kraj'

const KLUCZ = kluczKraju('vv:dane-projektu')

export const DOMYSLNE_DANE = {
  // Rodzaj połaci — pytany w ostatnim kroku asystenta, opisuje DACH, nie zestaw,
  // więc mieszka tu razem z resztą odpowiedzi o domu (patrz lib/konstrukcja).
  konstrukcja: KONSTRUKCJA_DOMYSLNA,
  // Czy do łącznego kosztu zestawu doliczamy szacunkowy montaż (cennik w
  // config/cennikMontazu). Domyślnie tak — kwota bez robocizny myli, bo nikt
  // nie kupuje instalacji, żeby złożyć ją samemu.
  montazWliczony: true,
  wojewodztwo: null,
  ustawienie: 'poludnie',
  zacienienie: 'brak',
  zuzycieRoczne: 0,
  profil: 'klasyczny',
  dodatki: [],
  // Ekonomia — uzupełniana dopiero w sekcji opłacalności.
  kosztOd: null,
  kosztDo: null,
  ulga: 'brak',
  dotacjaZl: 0,
  wzrostCen: null,
}

export const odczytajDaneProjektu = () => {
  try {
    return { ...DOMYSLNE_DANE, ...(JSON.parse(sessionStorage.getItem(KLUCZ)) || {}) }
  } catch {
    return { ...DOMYSLNE_DANE }
  }
}

export const zapiszDaneProjektu = (czesc) => {
  const scalone = { ...odczytajDaneProjektu(), ...czesc }
  try {
    sessionStorage.setItem(KLUCZ, JSON.stringify(scalone))
  } catch {
    // Prywatne okno — VoltValue Projekt ma działać dalej, tylko bez pamięci między ekranami.
  }
  return scalone
}

/**
 * Przeniesienie odpowiedzi z kalkulatora mocy.
 *
 * Kalkulator pyta o zużycie na trzy sposoby (kWh, rachunek, liczba osób) — tutaj
 * potrzebna jest już tylko wyliczona liczba kilowatogodzin, więc zapisujemy wynik,
 * a nie drogę dojścia. Zacienienie i orientacja przechodzą wprost: to te same
 * pytania z tymi samymi odpowiedziami.
 */
export const zapiszZKalkulatoraMocy = (f, zuzycieRoczne) => zapiszDaneProjektu({
  ustawienie: f.orientacja,
  zacienienie: f.zacienienie,
  profil: f.profil,
  dodatki: f.dodatki || [],
  zuzycieRoczne,
})
